// extracted by mini-css-extract-plugin
export default {"colorIcon":"Nc5Uu","icon":"xY7iX Qfqdm"};